import { defineStore } from 'pinia';
import Parse from '@/store/parseInitialization';

export const useMedicineStore = defineStore('medicine', {
  state: () => ({
    injectables: [],
    orals: [],
    infusions: [],
  }),
  actions: {
    async getAllMedicines() {
      try {
        const response = await Parse.Cloud.run('allMedicineByType');
        this.injectables = response.injectables;
        this.orals = response.orals;
        this.infusions = response.infusions;
      } catch (error) {
        throw new Error(error.message);
      }
    },
  },
});
